(function () {

    'use strict';

    $('#mol-header-search #header-search-close').on('click', function () {

        $(this).parents('#mol-header-search').removeClass('opened');
    });

})();
